import {
    extractProperties,
    isEmpty,
} from '.'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatState} from 'api/types'
import {NinchatTranscriptFoundEvent} from '../types/events'

export const transcriptFound: CaseReducer<NinchatState> = (state, action) => {
    const {
        audience_id,
        queue_id,
        realm_id,
        complete_time,
        assign_user_id,
        transcript_status,
        ...omitted
    } = extractProperties<NinchatTranscriptFoundEvent>(action.payload)

    // Omit channel_id and dialogue_id since we are not using them
    const {
        channel_id, // eslint-disable-line @typescript-eslint/no-unused-vars
        dialogue_id, // eslint-disable-line @typescript-eslint/no-unused-vars
        ...rest
    } = omitted

    isEmpty(rest)

    if (audience_id) {
        if (transcript_status === 'done' || !assign_user_id) {
            // Remove from sidebar if I set transcript assigned to me as "done" / unassign
            delete state._user_audience_transcripts[audience_id]
        }

        if (complete_time && queue_id && realm_id) {
            if (transcript_status !== 'done' && assign_user_id === state.user_id) {
                // Assigned to me: move from _audience_transcripts to _user_audience_transcripts
                delete state._audience_transcripts[audience_id]

                state._user_audience_transcripts[audience_id] = {
                    assign_user_id,
                    audience_id,
                    complete_time,
                    queue_id,
                    realm_id,
                    transcript_status,
                }
            }

            if (assign_user_id !== state.user_id) {
                state._audience_transcripts[audience_id] = {
                    assign_user_id,
                    audience_id,
                    complete_time,
                    queue_id,
                    realm_id,
                    transcript_status,
                }
            }
        }
    }
}
